export class EmailVerificationError extends Error {}
